
import moment from 'moment'

const convertMinsToHrsMins = (minutes) => {
  var h = Math.floor(minutes / 60);
  var m = minutes % 60;
  h = h < 10 ? '0' + h : h;
  m = m < 10 ? '0' + m : m;
  return h + ':' + m;
}

// export const toAMPM = (time) => moment(time, 'h:mm').format('h:mm A')
export const toAMPM = (time) => moment(sliderToTime(time), 'h:mm').format('h:mm A')

export const sliderToTime = (time) => convertMinsToHrsMins(time*60)

export const toSlider = (time) => moment(time, 'h:mm').hours() + (moment(time, 'h:mm').minutes()/60)



export const formatHourRange = (range) =>
  range && range
  .map(time=> toSlider(time) )


export const dateRangeToStrings = (state, dates = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]) => dates.reduce(function (allDates, day) {
  allDates[day] = state[day] && state[day].map(t=>sliderToTime(t))
  return allDates;
}, {});

// https://stackoverflow.com/questions/286141/remove-blank-attributes-from-an-object-in-javascript


export const getEnabledDays = (weekdays) => Object.keys(weekdays).filter(day=> weekdays[day])

export const getWorkHours = (state) => {
  const dates = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ]
  const range = dates.reduce((a, c)=>{
    a[c] = formatHourRange(state[c])
    return a
  },{})

  return {
    ...state,
    ...range,
    enabledDays: getEnabledDays(range)

  }
}

// NOTE purpose is fixed i.e. Commute, Work

// *_income_source can have custom

const initialState = {
  "Monday": [9, 17],
  "Tuesday": [9, 17],
  "Wednesday": [9, 17],
  "Thursday": [9, 17],
  "Friday": [9, 17],
  "Saturday": null,
  "Sunday": null,
  enabled: true,
  outside: "Commute", // purpose
  inside: "Work",
  outside_income_source: "",
  inside_income_source: "Everlance",
  range: [],
  enabledDays: [
    // 'Tuesday',
    // 'Wednesday',
    // 'Thursday',
    // 'Friday'
  ],
}


function workHours(state=initialState, action) {
  switch (action.type) {
    case "TOGGLE_DAY":
      if (state.enabledDays.includes(action.day)) return {
        ...state,
        [action.day]: null,
        enabledDays: state.enabledDays.filter(day=> day!==action.day)
      }
      return {
        ...state,
        [action.day]: [9, 17],
        enabledDays: [
          ...state.enabledDays,
          action.day
        ]
      }
    case "USER_SUCCESS":
      return {
        ...state,
        ...getWorkHours(action.user.work_hours),
      }
    case "UPDATE_WORK_HOURS_RANGE":
      return {
        ...state,
        [action.payload.day]: action.payload.range
      }

    default:
      return state
  }
}

export default workHours



// WEBPACK FOOTER //
// ./src/account/work-hours/reducer.js